module.exports = __webpack_public_path__ + "static/BT-desktop-4-f02474fc875c6a0a97145b96240283e2.jpg";